/**
 * US & Canada (NANP) phone validation helpers.
 * Accepts common formats: (778) 851-0830, +1 778-851-0830, 778.851.0830, etc.
 */

const NANP_NXX = /^[2-9]\d{2}$/;

/** Digits only, national 10-digit form (no country code). */
export function extractNanpDigits(raw: string): string | null {
  const withoutExt = raw.trim().split(/[xX#]/)[0] ?? "";
  const digits = withoutExt.replace(/\D/g, "");

  if (digits.length === 11 && digits.startsWith("1")) {
    return digits.slice(1);
  }
  if (digits.length === 10) {
    return digits;
  }
  return null;
}

export function isUsCanadaPhone(raw: string): boolean {
  const trimmed = raw.trim();
  if (!trimmed) return false;
  // Reject letters other than extension markers already stripped above
  if (/[a-wyz]/i.test(trimmed.replace(/[xX].*$/, ""))) return false;

  const national = extractNanpDigits(trimmed);
  if (!national) return false;

  const area = national.slice(0, 3);
  const exchange = national.slice(3, 6);

  if (!NANP_NXX.test(area) || !NANP_NXX.test(exchange)) return false;
  // N11 area codes are reserved (411, 911, etc.)
  if (area[1] === "1" && area[2] === "1") return false;

  return true;
}

/** Normalize to E.164-style +1XXXXXXXXXX for HubSpot. */
export function normalizeUsCanadaPhone(raw: string): string {
  const national = extractNanpDigits(raw);
  if (!national) return raw.trim();
  return `+1${national}`;
}
